import React from 'react';
import PropTypes from 'prop-types'; // import { Breadcrumb } from 'react-bootstrap';

import { MaterialUiCore } from '@gscope-mfe/common-libs';
import styles from './BreadCrumbs.module.css';
const { Link } = MaterialUiCore;
const { Breadcrumbs } = MaterialUiCore;

const BreadCrumb = ({ breadcrumbArr }) => (
    <div className={styles.breadCrumbContainer}>
        <Breadcrumbs>
            {breadcrumbArr.map(({ link, active, label }) => {
                if (active) return <span key={link + label}>{label}</span>;
                return (
                    <Link href={link} key={link + label}>
                        {label}
                    </Link>
                );
            })}
        </Breadcrumbs>
    </div>
);

BreadCrumb.propTypes = {
    breadcrumbArr: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default BreadCrumb;
